import { MODE_TRANSFER } from '@/lib/constants';
import { OptionModel } from '@/lib/models/option/types';

export const getOptionTransferLocationIds = (option: OptionModel): string[] => {
  return option.segments.reduce((acc, segment) => {
    if (segment.transferType === MODE_TRANSFER) {
      return [...acc, segment.fromId];
    }

    return acc;
  }, [] as string[]);
};
